import { render, staticRenderFns } from "./VerifierWithRouter.vue?vue&type=template&id=ee21681e&"
import script from "./VerifierWithRouter.vue?vue&type=script&lang=js&"
export * from "./VerifierWithRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee21681e')) {
      api.createRecord('ee21681e', component.options)
    } else {
      api.reload('ee21681e', component.options)
    }
    module.hot.accept("./VerifierWithRouter.vue?vue&type=template&id=ee21681e&", function () {
      api.rerender('ee21681e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/components/VerifierWithRouter.vue"
export default component.exports